import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

import JCRLogoIcon from '../icons/JCRLogoIcon';
import FKLogoIcon from '../icons/FKLogoIcon';

function Footer({ className }) {
  return (
    <Fragment>
      <footer className={'footer ' + className}>
        <div className="row">
          <div className="footer__content">
            <div className="footer__info">
              <div className="footer__links">
                <Link to="/privacy-policy">
                  Privacy Policy
                </Link>
              </div>
              <p className="footer__text">
                {`© ${new Date().getFullYear()} `}
                Joint Commission Resources. Joint Commission Resources’ production of this tool, as sponsored by Fresenius Kabi USA, LLC, is on a non-exclusive basis, and is not an endorsement of that company or its products, or a statement that its expertise or products are superior to those of other comparable companies. Joint Commission Resources and The Joint Commission as a matter of policy, do not endorse products.
              </p>
            </div>
            <div className="footer__logos">
              <a
                href="https://www.jcrinc.com/"
                className="footer__logo"
                target="_blank"
                rel="noopener noreferrer"
              >
                <JCRLogoIcon />
              </a>
              <a
                href="https://www.fresenius-kabi.com/"
                className="footer__logo"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FKLogoIcon />
              </a>
            </div>
          </div>
        </div>
      </footer>
    </Fragment>
  );
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/common/Footer.js